module.exports = __webpack_public_path__ + "img/平安园区.5a776614.png";